import BottomSheet from './BottomSheet';
import Button from './Button';
import { t } from '../i18n/langue';

/**
 * « Outils de rédaction », sous le « + » du composeur — extrait de #84.
 *
 * Trois entrées possibles, chacune propre à un canal ou proposée partout :
 * les messages rapides (partout), le message type WhatsApp (canal WhatsApp),
 * et le modèle d'e-mail à choisir dans la bibliothèque (canal e-mail — retour
 * client 2026-09-25).
 */
interface OutilsRedactionProps {
    ouverte: boolean;
    onClose: () => void;
    /** Le message type WhatsApp n'a de sens que sur ce canal. */
    surWhatsapp: boolean;
    /** Le modèle d'e-mail n'a de sens que sur ce canal. */
    surEmail: boolean;
    onOuvrirMessagesRapides: () => void;
    onOuvrirModeles: () => void;
    onOuvrirModelesEmail: () => void;
}

export default function OutilsRedaction({
    ouverte,
    onClose,
    surWhatsapp,
    surEmail,
    onOuvrirMessagesRapides,
    onOuvrirModeles,
    onOuvrirModelesEmail,
}: OutilsRedactionProps) {
    return (
        <BottomSheet
            ouverte={ouverte}
            onClose={onClose}
            libelle={t('composeur.outils.titre')}
            libelleFermeture={t('composeur.outils.fermer')}
        >
            <Button
                libelle={t('composeur.rapides.titre')}
                variante="discret"
                alignement="debut"
                pleineLargeur
                onPress={onOuvrirMessagesRapides}
            />
            {surWhatsapp && (
                <Button
                    libelle={t('composeur.outils.envoyerModele')}
                    variante="discret"
                    alignement="debut"
                    pleineLargeur
                    onPress={onOuvrirModeles}
                />
            )}
            {surEmail && (
                <Button
                    libelle={t('composeur.modelesEmail.titre')}
                    variante="discret"
                    alignement="debut"
                    pleineLargeur
                    onPress={onOuvrirModelesEmail}
                />
            )}
        </BottomSheet>
    );
}
